import { render, staticRenderFns } from "./ServiceCreationHeader.vue?vue&type=template&id=640b9a80&scoped=true&"
import script from "./ServiceCreationHeader.vue?vue&type=script&lang=js&"
export * from "./ServiceCreationHeader.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCreationHeader.vue?vue&type=style&index=0&id=640b9a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b9a80",
  null
  
)

export default component.exports